// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RoleDetailsQueryVariables = Types.Exact<{
  organizationRoleId: Types.Scalars["ID"]["input"];
}>;

export type RoleDetailsQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationRoleDetails?: {
    __typename?: "OrganizationRole";
    id: string;
    name: string;
    permittedToEditRole: boolean;
    permittedToRemoveRole: boolean;
    validMemberships: Array<{
      __typename?: "OrganizationMembership";
      id: string;
      inviteEmail?: string | null;
      accepted: boolean;
      user?: {
        __typename?: "User";
        id: string;
        avatarUrl?: string | null;
        fullname?: string | null;
        email: string;
      } | null;
    }>;
    permissions: Array<{
      __typename?: "OrganizationPermission";
      id: string;
      restricted: boolean;
      view: boolean;
      modify: boolean;
      billing: boolean;
      api: boolean;
      manage: boolean;
      createWorkbooks: boolean;
      database?: { __typename?: "Database"; displayName: string } | null;
      server?: { __typename?: "Server"; name: string } | null;
      serverGroup?: { __typename?: "ServerGroup"; name: string } | null;
    }>;
  } | null;
};

export const RoleDetailsDocument = gql`
  query RoleDetails($organizationRoleId: ID!) {
    getOrganizationRoleDetails(roleId: $organizationRoleId) {
      id
      name
      permittedToEditRole
      permittedToRemoveRole
      validMemberships {
        id
        inviteEmail
        accepted
        user {
          id
          avatarUrl
          fullname
          email
        }
      }
      permissions {
        id
        database {
          displayName
        }
        server {
          name
        }
        serverGroup {
          name
        }
        restricted
        view
        modify
        billing
        api
        manage
        createWorkbooks
      }
    }
  }
`;

/**
 * __useRoleDetailsQuery__
 *
 * To run a query within a React component, call `useRoleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleDetailsQuery({
 *   variables: {
 *      organizationRoleId: // value for 'organizationRoleId'
 *   },
 * });
 */
export function useRoleDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RoleDetailsQuery,
    RoleDetailsQueryVariables
  > &
    (
      | { variables: RoleDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RoleDetailsQuery, RoleDetailsQueryVariables>(
    RoleDetailsDocument,
    options,
  );
}
export function useRoleDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RoleDetailsQuery,
    RoleDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RoleDetailsQuery, RoleDetailsQueryVariables>(
    RoleDetailsDocument,
    options,
  );
}
// @ts-ignore
export function useRoleDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RoleDetailsQuery,
    RoleDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RoleDetailsQuery, RoleDetailsQueryVariables>;
export function useRoleDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RoleDetailsQuery,
        RoleDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RoleDetailsQuery | undefined,
  RoleDetailsQueryVariables
>;
export function useRoleDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RoleDetailsQuery,
        RoleDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RoleDetailsQuery, RoleDetailsQueryVariables>(
    RoleDetailsDocument,
    options,
  );
}
export type RoleDetailsQueryHookResult = ReturnType<typeof useRoleDetailsQuery>;
export type RoleDetailsLazyQueryHookResult = ReturnType<
  typeof useRoleDetailsLazyQuery
>;
export type RoleDetailsSuspenseQueryHookResult = ReturnType<
  typeof useRoleDetailsSuspenseQuery
>;
export type RoleDetailsQueryResult = Apollo.QueryResult<
  RoleDetailsQuery,
  RoleDetailsQueryVariables
>;
